import * as React from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { FgtsDashboard } from './dash';
import { CltDashboard } from './clt/dash';


export  function DashPage() {
  const [value, setValue] = React.useState('1');

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', typography: 'body1' }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList centered onChange={handleChange} aria-label="lab API tabs example">
            <Tab label="Fgts" value="1" />
            <Tab label="Clt" value="2" />
          </TabList>
        </Box>
        <TabPanel value="1"><FgtsDashboard/></TabPanel>
        <TabPanel value="2"><CltDashboard/></TabPanel>
      </TabContext>
    </Box>
  );
}
